export default {
    SUM: 'sum',
    MAX: 'max',
    MIN: 'min',
    AVG: 'avg',
    MEDIAN:'median',
    COUNT: 'count',
    // NONE: 'none'
}